import { WSLoader, WSTableCell } from "@wingspanhq/fe-component-library";
import React from "react";
import { useQueryMemberPrivateFile } from "../../../query/files/queries";

type Props = {
  fileId: string;
};

export const FileNameCell: React.FC<Props> = ({ fileId }) => {
  const queryFile = useQueryMemberPrivateFile(fileId);

  if (queryFile.isLoading) {
    return <WSLoader.Spinner size="XS" />;
  }

  const filename = queryFile.data?.filename || "Unknown file";
  return <WSTableCell text={filename} />;
};
